import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageHeaderComponent } from '../../atoms/page-header/page-header.component';
import { AlarmsCardComponent } from '../../molecules/alarms-card/alarms-card.component';
import { InfoCardComponent } from '../../molecules/info-card/info-card.component';
import { EventsCardComponent } from '../../molecules/events-card/events-card.component';
import { IconComponent } from '../../atoms/icon/icon.component';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { BadgeCopyComponent } from '../../molecules/indicators/rsabt-indicator-copy.component';
import { LoaderWrapperComponent } from '../../atoms/loader-wrapper/loader-wrapper.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PageHeaderComponent,
    TranslocoDirective,
    EventsCardComponent,
    AlarmsCardComponent,
    InfoCardComponent,
    IconComponent,
    TranslocoDatePipe,
    BadgeCopyComponent,
    LoaderWrapperComponent,
  ],
  selector: 'ui-center-header',
  template: `
    <ng-container *transloco="let t">
      <ui-page-header>
        <div class="col-span-1 sm:col-span-4 xl:col-span-6">
          <ui-info-card [title]="t('CENTER.NAME') + ': ' + centerName()" icon="icons:center" [iconClasses]="'text-3xl'">
            <ui-badge-copy [id]="centerId()" />
            @if (centerUpdatedAt()) {
              <p class="text-gray-500 flex mt-1 gap-x-1 sm:gap-x-2">
                {{ t('CENTER.UPDATE') }}:
                <ui-icon icon="wifi" [class]="wifiIconClass()" />
                {{
                  centerUpdatedAt()!
                    | translocoDate: { dateStyle: 'short', timeStyle: 'medium' }
                }}
              </p>
            }
          </ui-info-card>
        </div>
        <div class="col-span-1 sm:col-span-4 xl:col-span-3">
          <ui-loader
            [loading]="loadingAlarmsCount()"
            loadingType="skeletonCard"
          >
            <ui-alarms-card
              [alarmsUnreadCount]="alarmsUnreadCount()"
              [alarmsActiveCount]="alarmsActiveCount()"
              (alarmsLinkClick)="handleAlarmsLinkClick()"
            />
          </ui-loader>
        </div>
        <div class="col-span-1 sm:col-span-4 xl:col-span-3">
          <ui-loader
            [loading]="loadingEventsCount()"
            loadingType="skeletonCard"
          >
            <ui-events-card
              [eventsUnreadCount]="eventsUnreadCount()"
              (eventsLinkClick)="handleEventsLinkClick()"
            />
          </ui-loader>
        </div>
      </ui-page-header>
    </ng-container>
  `,
})
export class CenterHeaderComponent {
  eventsUnreadCount = input<number | null>(null);
  alarmsUnreadCount = input<number | null>(null);
  alarmsActiveCount = input<number | null>(null);
  loadingEventsCount = input<boolean>(true);
  loadingAlarmsCount = input<boolean>(true);
  centerName = input<string>('');
  centerId = input<string>('');
  centerUpdatedAt = input<Date | null>(null);
  alarms = input<Array<{ parameter: string; severity: string }>>([]);

  alarmsLinkClick = output<void>();
  eventsLinkClick = output<void>();

  wifiIconClass = computed(() => {
    const alarms = this.alarms();
    const hasUpdatedAtAlarm = alarms.some(alarm => alarm.parameter === 'updatedAt');
    return hasUpdatedAtAlarm ? 'text-red-400' : 'text-green';
  });

  handleAlarmsLinkClick() {
    this.alarmsLinkClick.emit();
  }

  handleEventsLinkClick() {
    this.eventsLinkClick.emit();
  }
}
